"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImagePreviewHref = getImagePreviewHref;
exports.formatFileExtensions = formatFileExtensions;
exports.transformFileExtensionsForDisplay = transformFileExtensionsForDisplay;
exports.getFileExtension = getFileExtension;
const MimeTypeHelper_1 = require("./MimeTypeHelper");
function getImagePreviewHref(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                resolve(reader.result.toString());
            });
            reader.addEventListener('error', event => {
                reject(event);
            });
            if (file) {
                reader.readAsDataURL(file);
            }
        });
    });
}
/**
 * Look for mime type directive and get mime types for file types from file extension result.
 * @param fileExtensions
 * @param fileMimeTypes
 * @param defaultFileExtensions
 * @param defaultMimeTypes
 */
function formatFileExtensions(fileExtensions, fileMimeTypes, defaultFileExtensions, defaultMimeTypes) {
    var _a, _b;
    const allowedFileTypes = (_a = fileExtensions !== null && fileExtensions !== void 0 ? fileExtensions : defaultFileExtensions) !== null && _a !== void 0 ? _a : [];
    const allowedFileTypesFormatted = allowedFileTypes
        .map(fileType => fileType.replace('*.', ''))
        .join(', ');
    const allowedMimeTypes = (_b = fileMimeTypes !== null && fileMimeTypes !== void 0 ? fileMimeTypes : defaultMimeTypes) !== null && _b !== void 0 ? _b : [];
    const fileAcceptsSet = new Set(allowedMimeTypes);
    allowedFileTypes
        .map(fileType => fileType.replace('*.', ''))
        .forEach(allowedFileType => {
        var _a;
        fileAcceptsSet.add((_a = (0, MimeTypeHelper_1.getMimeTypeForExtension)(`*.${allowedFileType}`)) !== null && _a !== void 0 ? _a : `.${allowedFileType}`);
    });
    const allowedMimeTypesFormatted = allowedMimeTypes.join(',');
    const fileAccepts = [...fileAcceptsSet].join(',');
    return {
        allowedFileTypes,
        allowedFileTypesFormatted,
        allowedMimeTypes,
        allowedMimeTypesFormatted,
        fileAccepts
    };
}
/** converts an array of file extensions into a readable format */
function transformFileExtensionsForDisplay(extensions, locale) {
    const set = new Set();
    // Remove duplicates and get all capitalized versions
    extensions === null || extensions === void 0 ? void 0 : extensions.forEach(value => {
        let transformedValue = value.toUpperCase();
        // Remove wildcards
        if (transformedValue.startsWith('*.')) {
            transformedValue = transformedValue.slice(2);
        }
        set.add(transformedValue);
    });
    // Convert back to array
    const values = [...set.values()];
    const formatter = new Intl.ListFormat(locale !== null && locale !== void 0 ? locale : 'en', { type: 'disjunction' });
    return formatter.format(values);
}
/**
 * Extracts the file extension from a given URL.
 *
 * @param {string} url - The URL from which to extract the file extension.
 * @returns {string | null} The file extension in lowercase, or null if no extension is found.
 *
 */
function getFileExtension(url) {
    const parts = url.split(/[#?]/);
    const filenameWithExtension = parts[0].split('/').pop();
    const extension = (filenameWithExtension === null || filenameWithExtension === void 0 ? void 0 : filenameWithExtension.includes('.'))
        ? filenameWithExtension.split('.').pop()
        : null;
    return extension ? extension.toLowerCase() : null;
}
//# sourceMappingURL=FileHelper.js.map